import { SnippetsBanners, SnippetsTable } from 'modules/productAnalytics/snippets/components';
import { SnippetsContextProvider } from 'modules/productAnalytics/snippets/context';
import { SnippetsTableModes } from 'modules/productAnalytics/snippets/types';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { colors, largeShadow, spacing } from 'ui/theme';
import { ExpandModes, ExpansionContextProvider } from 'utils/contexts/expansion';
import { useTabSpecificFiltersContext, useTimeFiltersContext } from '../context';
import { selectCampaignIdsToFetchMetrics } from '../selectors';
import { DateParams } from '../types';

const TableWrapper = styled.div`
  background: ${colors.white};
  border-radius: ${spacing.quarter};
  box-shadow: ${largeShadow.boxShadow};
`;

export const Snippets = () => {
  const campaignIds = useSelector(selectCampaignIdsToFetchMetrics);
  const { dateParams = {} } = useTimeFiltersContext();
  const { snippetsSortDirection, snippetsSortedBy, setSnippetsSortDirection, setSnippetsSortedBy } =
    useTabSpecificFiltersContext();

  const { startTime: startDate, endTime: endDate } = dateParams as DateParams;

  return (
    <SnippetsContextProvider
      mode={SnippetsTableModes.MessagingInsights}
      campaignIds={campaignIds}
      startTime={startDate?.format()}
      endTime={endDate?.format()}
      sort={{
        snippetsSortDirection,
        snippetsSortedBy,
        setSnippetsSortDirection,
        setSnippetsSortedBy,
      }}
    >
      <ExpansionContextProvider
        localKey="messaging-insights-snippets"
        initialMode={ExpandModes.collapse}
      >
        <SnippetsBanners />
        <TableWrapper>
          <SnippetsTable showCampaignToggle />
        </TableWrapper>
      </ExpansionContextProvider>
    </SnippetsContextProvider>
  );
};
